/**
 *
 * Asynchronously loads the component for Reservations History Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ServiceRequestPage = lazyLoad(
  () => import('./index'),
  module => module.ServiceRequestListPage,
);
